import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Form, FormGroup, Input, Badge } from "reactstrap";
import "./InternStyling.css"; // Import CSS

const API_URL = "https://app.rlagency.id/api_internship/internship_position.php";

const InternPositionManagement = () => {
  const [positions, setPositions] = useState([]);
  const [positionName, setPositionName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchPositions();
  }, []);

  // Ambil data posisi dari API
  const fetchPositions = async () => {
    setLoading(true);
    try {
      const response = await axios.get(API_URL);
      const formattedData = response.data.map(item => ({
        ...item,
        status: Number(item.status), // Pastikan status menjadi angka
        portfolio_needed: Number(item.portfolio_needed), // Pastikan portfolio_needed menjadi angka
      }));
      setPositions(formattedData);
    } catch (error) {
      console.error("Error fetching positions:", error);
      setPositions([]);
    }
    setLoading(false);
  };

  // Tambah posisi baru
  const addPosition = async () => {
    if (!positionName.trim()) {
      alert("Nama posisi tidak boleh kosong!");
      return;
    }
    try {
      await axios.post(API_URL, { position: positionName });
      setPositionName("");
      fetchPositions();
    } catch (error) {
      console.error("Error adding position:", error);
    }
  };

  // Toggle status atau portfolio_needed
  const toggleField = async (id, column) => {
    try {
      await axios.put(API_URL, { id, column });
      fetchPositions();
    } catch (error) {
      console.error(`Error updating ${column}:`, error);
    }
  };

  return (
    <div >
      {/* Form Tambah Posisi */}
      <Form >
        <FormGroup>
          <Input
            type="text"
            value={positionName}
            onChange={(e) => setPositionName(e.target.value)}
            placeholder="Masukkan nama posisi baru"
          />
        </FormGroup>
        <Button color="primary" onClick={addPosition}>Tambah Posisi Baru</Button>
      </Form>

      {/* Tabel Daftar Posisi */}
      {loading ? <p>Loading...</p> : (
        <Table bordered>
          <thead>
            <tr>
              <th style={{ width: "70px", textAlign: "center" }}>No.</th>
              <th>Nama Posisi Tersedia</th>
              <th>Status</th>
              <th>Portfolio Needed</th>
            </tr>
          </thead>
          <tbody>
            {positions.map((pos, index) => (
              <tr key={pos.id}>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>{index + 1}</td>
                <td style={{ verticalAlign: "middle" }}>{pos.position}</td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  <Badge
                    color={pos.status === 1 ? "success" : "danger"}
                    onClick={() => toggleField(pos.id, "status")}
                    style={{ cursor: "pointer" }}
                  >
                    {pos.status === 1 ? "Aktif" : "Non-Aktif"}
                  </Badge>
                </td>
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                  <Badge
                    color={pos.portfolio_needed === 1 ? "success" : "danger"}
                    onClick={() => toggleField(pos.id, "portfolio_needed")}
                    style={{ cursor: "pointer" }}
                  >
                    {pos.portfolio_needed === 1 ? "Diperlukan" : "Tidak"}
                  </Badge>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default InternPositionManagement;
